<template>
	<div class="topic-analysis">
		<div class="big-title" v-if="isViewState"><slot name="subjectName" /></div>
		<titles><template #mainTitle>命题分析</template></titles>
		<div class="current-title title">
			试题分析指标明细表
			<span v-if="!isViewState" class="look-origin" @click="secondTitleOpe">查看试题原卷</span>
		</div>
		<div class="current-second-title">
			试题分析指标明细表，展示每个试题多个测试的指标数据，数据内容较丰富，各个数据都是描述试题表现出的某方面特性。
		</div>
		<hm-table :tableOptions="quoteTableOption" :isShowOpeColumn="isShowOpeColumn" :isTableShowMore="isTableShowMore">
			<div slot="operate" slot-scope="{ data }">
				<el-link class="look-origin-link" type="primary" @click.stop.prevent="lookOriginQus(data)">查看原题</el-link>
			</div>
		</hm-table>
		<div class="difficult-title title">试题难度分布结构表</div>
		<div class="difficult-second-title">
			本学科的整体难度为：<strong v-show="difficultRate">{{ difficultRate }}，</strong>各试题的难度分布有一定的结构比例。
		</div>
		<div class="pie-wrap">
			<div class="pie-list center"><vue-echarts :options="objectiveOption" class="charts" /></div>
			<div class="pie-list center"><vue-echarts :options="subjectiveOption" class="charts" /></div>
		</div>
		<div class="difficult-second-title marginbtm15" style="margin-top: 10px">
			从客观题，主观题试题难度结构来看，考试试题的难度分布情况见下表([]：表示为同一题块)：
		</div>
		<hm-table :tableOptions="difficultTableOption" :isTableShowMore="isTableShowMore"></hm-table>
		<div class="district-title">
			<span class="district-main-title">试题难度-区分度分布图</span>
			<span class="district-second-title">将每一个试题的难度，区分度结合起来分析</span>
		</div>
		<div class="scatter-wrap">
			<vue-echarts :options="scatterOption" class="charts" />
		</div>
	</div>
</template>
<script>
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/markArea'
import vueEcharts from 'vue-echarts'
export default {
	name: 'topic-analysis',
	components: {
		titles: () => import('./title'),
		hmTable: () => import('hm-table'),
		vueEcharts
	},
	data() {
		return {
			objectiveOption: {},
			subjectiveOption: {},
			scatterOption: {},
			quoteTableOption: [],
			difficultTableOption: [],
			difficultRate: '',
			headList: []
		}
	},
	watch: {
		quoteTable: {
			handler(val) {
				this.quoteTableOption = val
			},
			immediate: true,
			deep: true
		},
		subOrObjOptions: {
			handler(val) {
				if (val) {
					this.difficultTableOption = val.difficultTableOption
					this.difficultRate = val.difficultRate
					this.objectiveEcharts(val.lenged, val.objDataList)
					this.subjectiveEcharts(val.lenged, val.subDataList)
				}
			},
			immediate: true,
			deep: true
		},
		scatterList: {
			handler(val) {
				this.scatterOptionMeans(1, 1, val)
			},
			immediate: true,
			deep: true
		}
	},
	props: {
		isShowOpeColumn: {
			type: Boolean,
			default: false
		},
		quoteTable: {
			type: Array,
			default: () => []
		},
		subOrObjOptions: {
			type: Object,
			default: () => {}
		},
		scatterList: {
			type: Array,
			default: () => []
		},
		isViewState: {
			type: Boolean,
			default: false
		},
		isTableShowMore: {
			type: Boolean,
			default: false
		},
		pieTitlePos: {
			type: Object,
			default: () => {
				return {
					top: 150,
					left: 250
				}
			}
		}
	},
	methods: {
		// 查看原卷
		secondTitleOpe() {
			this.$emit('secondTitleOpe')
		},
		// 查看原题
		lookOriginQus(val) {
			this.$emit('lookOriginQus', val)
		},
		// ECHARTS 客观
		objectiveEcharts(legend, objDataList) {
			this.objectiveOption = {
				title: {
					show: true,
					text: '客观题',
					top: this.pieTitlePos.top,
					left: this.pieTitlePos.left,
					textStyle: {
						color: '#333',
						fontStyle: 'normal',
						fontSize: 23
					}
				},
				legend: {
					show: true,
					data: legend,
					itemWidth: 26,
					itemHeight: 13,
					bottom: 0,
					textStyle: {
						fontSize: 13
					}
				},
				tooltip: {
					show: true,
					formatter: function(data) {
						return `难度：${data.data.name}<br/>数量：${data.data.value}`
					}
				},
				color: ['#009688', '#0e7ce2', '#FF8352', '#F8456B', '#2bca62'],
				series: [
					{
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '46%'],
						data: objDataList,
						hoverAnimation: true,
						itemStyle: {
							normal: {
								borderColor: '#ffffff',
								borderWidth: 2
							}
						},
						labelLine: {
							normal: {
								length: 15,
								length2: 38,
								lineStyle: {
									color: '#3d3f3d'
								}
							}
						},
						label: {
							fontSize: 15
						}
					}
				]
			}
		},
		//ECHARTS  主观
		subjectiveEcharts(legend, subDataList) {
			this.subjectiveOption = {
				title: {
					show: true,
					text: '主观题',
					top: this.pieTitlePos.top,
					left: this.pieTitlePos.left,
					textStyle: {
						color: '#333',
						fontStyle: 'normal',
						fontSize: 23
					}
				},

				legend: {
					show: true,
					data: legend,
					itemWidth: 26,
					itemHeight: 13,
					bottom: 0,
					textStyle: {
						fontSize: 13
					}
				},
				tooltip: {
					show: true,
					formatter: function(data) {
						return `难度：${data.data.name}<br/>数量：${data.data.value}`
					}
				},
				color: ['#009688', '#0e7ce2', '#FF8352', '#F8456B', '#2bca62'],
				series: [
					{
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '46%'],
						data: subDataList,
						hoverAnimation: true,
						itemStyle: {
							normal: {
								borderColor: '#ffffff',
								borderWidth: 2
							}
						},
						labelLine: {
							normal: {
								length: 15,
								length2: 38,
								lineStyle: {
									color: '#3d3f3d'
								}
							}
						},
						label: {
							fontSize: 15
						}
					}
				]
			}
		},
		//	 ECHARTS 散点图
		scatterOptionMeans(xAsisData, yAsisData, seriesData) {
			this.scatterOption = {
				legend: {
					show: true,
					orient: 'horizontal',
					icon: 'roundRect',
					selectedMode: false,
					itemWidth: 26,
					itemHeight: 13,
					top: 10,
					textStyle: {
						fontSize: 13,
						color: '#0d0e0e'
					}
				},
				tooltip: {
					show: true,
					animation: true,
					trigger: 'item',
					backgroundColor: '#323436',
					borderColor: '#323436',
					borderWidth: 1,
					borderRadius: 3,
					textStyle: {
						color: '#fff',
						fontSize: 13,
						align: 'left'
					},
					formatter: function(data) {
						return '题号：' + data.value[2] + '<br/>' + '区分度：' + data.value[0] + '<br/>' + '难度：' + data.value[1]
					}
				},
				grid: {
					top: 40,
					left: 30,
					bottom: 20,
					right: 70
				},
				yAxis: {
					type: 'value',
					max: yAsisData,
					name: '难度',
					axisLine: {
						show: true,
						symbol: ['none', 'arrow'],
						symbolSize: [8, 10],
						lineStyle: {
							color: '#7c7878'
						}
					},
					splitLine: {
						show: true,
						lineStyle: { color: '#c1bebe', type: 'dashed' }
					}
				},
				xAxis: {
					type: 'value',
					max: xAsisData,
					name: '区分度',
					interval: 0.1,
					axisLine: {
						show: true,
						symbol: ['none', 'arrow'],
						symbolSize: [8, 10],
						lineStyle: { color: '#7c7878' }
					},
					splitLine: {
						show: true,
						lineStyle: { color: '#c1bebe', type: 'dashed' }
					}
				},
				series: [
					{
						name: '分布图',
						symbol: 'circle',
						symbolSize: 18,
						type: 'scatter',
						itemStyle: {
							normal: {
								color: '#009688'
							}
						},
						label: {
							show: true,
							position: 'bottom',
							formatter: '{b}'
						},
						markArea: {
							silent: true,
							data: [
								[
									{
										xAxis: 0,
										yAxis: 0.4,
										itemStyle: {
											color: 'rgba(248,0,76,0.1)'
										},
										label: {
											position: 'inside',
											color: 'rgba(214,11,11,0.1)',
											fontSize: 22
										}
									},
									{
										xAxis: 0.3,
										yAxis: 0
									}
								],
								[
									{
										xAxis: 0.3,
										yAxis: 0.4,
										itemStyle: {
											color: 'rgba(9,255,0,0.2)'
										},
										label: {
											position: 'inside',
											color: 'rgba(214,11,11,0.1)',
											fontSize: 22
										}
									},
									{
										xAxis: 0.5,
										yAxis: 0
									}
								],
								[
									{
										xAxis: 0,
										yAxis: 0.8,
										itemStyle: {
											color: 'rgb(255,219,0,0.1)'
										},
										label: {
											position: 'inside',
											color: 'rgba(214,11,11,0.1)',
											fontSize: 22
										}
									},
									{
										xAxis: 0.3,
										yAxis: 0.4
									}
								]
							]
						},
						data: seriesData
					}
				]
			}
		}
	}
}
</script>

<style scoped lang="less">
.topic-analysis {
	background: white;
	padding: 0 15px 30px;
	.center {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.charts {
		width: 100%;
		height: 100%;
	}
	.marginbtm15 {
		margin-bottom: 15px;
	}
	.title {
		font-size: 16px;
		padding-top: 10px;
	}
	.big-title {
		font-size: 21px;
	}
	.look-origin {
		color: #009688;
		font-size: 15px;
		&:hover {
			cursor: pointer;
		}
	}
	.current-title {
		margin-bottom: 15px;
	}
	.current-second-title {
		font-size: 13px;
		margin-bottom: 18px;
	}
	.difficult-title {
		font-size: 19px;
		margin-top: 20px;
	}
	.difficult-second-title {
		font-size: 15px;
		padding-top: 10px;
	}
	.pie-wrap {
		display: flex;
		justify-content: flex-start;
		margin-top: 10px;
	}
	.pie-list {
		height: 360px;
		flex: 1;
	}
	.district-title {
		margin-top: 35px;
		.district-main-title {
			font-size: 19px;
		}
		.district-second-title {
			font-size: 15px;
			padding-left: 15px;
		}
		@media print {
			.district-main-title {
				font-size: 24px;
			}
			.district-second-title {
				font-size: 20px;
			}
		}
	}
	.scatter-wrap {
		width: 100%;
		height: 360px;
	}
	/deep/.look-origin-link {
		color: #009688;
	}
	@media print {
		.title {
			font-size: 21px;
		}
		.current-second-title {
			font-size: 18px;
		}
		.difficult-title {
			font-size: 24px;
		}
		.difficult-second-title {
			font-size: 20px;
		}
	}
}
</style>
